/**
 * Created by brunopoeta on 10/05/17.
 */

export default function CardDirective() {

    return {
        scope: {
            align: '@',
            card: '=',
            subtitle: '=',
            subtitleColor: '@',
            subtitlePosition: '@',
            titleSize: '@'
        },
        replace: true,
        restrict: 'E',
        templateUrl: window.templateDirectory + '/assets/app/templates/card.html'
    }

}
